import { Video } from "lucide-react";
import { useLanding } from "@/context/LandingContext";
import { SEMINAR } from "@/seminars";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

export function SessionsSection() {
  const { t, events, lang, setSelectedIndex, scrollTo } = useLanding();
  const s = t.sessions;
  const closed = SEMINAR.registrationClosed;
  const groups = [
    { key: "English", label: s.englishGroup },
    { key: "Chinese", label: s.chineseGroup },
  ];
  const reserve = (index) => {
    setSelectedIndex(index);
    scrollTo("#register");
  };
  return (
    <InteractiveSection className="section session-list-section" id="sessions" data-testid="sessions-section">
      <MotionBg variant="spotlight" dots={3} />
      <div className="container">
        <Reveal className="section-head center">
          <p className="eyebrow"><span className="eyebrow-no">09</span>{s.eyebrow}</p>
          <h2>{s.title}</h2>
          <p className="subhead">{closed ? t.closed.sessionsNote : s.lead}</p>
        </Reveal>
        <div className="session-groups">
          {groups.map((group) => (
            <Reveal className="session-lang-group" key={group.key} data-testid={`session-group-${group.key.toLowerCase()}`}>
              <p className="session-lang-heading">{group.label}</p>
              <div className="session-cards">
                {events.map((event, index) =>
                  event.language === group.key ? (
                    <article className={`session-list-card${closed ? " session-list-card-closed" : ""}`} key={event.iso} data-testid={`session-card-${index}`}>
                      <div className="session-list-date">{event.label[lang]}</div>
                      <div className="session-list-speaker" data-testid={`session-speaker-${index}`}>{event.speaker}</div>
                      <div className="session-list-meta" data-testid={`session-time-${index}`}>{s.time}</div>
                      <div className="session-list-format" data-testid={`session-format-${index}`}><Video size={13} aria-hidden="true" /> {s.format}</div>
                      {closed ? (
                        <span className="session-list-closed" data-testid={`session-closed-${index}`}>{t.closed.badge}</span>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-gold session-list-btn"
                          onClick={() => reserve(index)}
                          data-testid={`session-reserve-${index}`}
                        >
                          {s.reserve} <span className="arrow">→</span>
                        </button>
                      )}
                    </article>
                  ) : null,
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </InteractiveSection>
  );
}
